import Immutable from 'app/utils/immutable/Immutable';
import { graphql } from 'graphql/client';
import { _getData } from 'app/utils/redux/action-utils';
import { formatSearchResults } from 'app/utils/search/globalSearchUtils';
import { globalSearchQuery } from 'graphql/entities/entities/globalSearchQuery';

export const EXECUTE_GLOBAL_SEARCH_STARTED = '@@affectli/search/EXECUTE_GLOBAL_SEARCH_STARTED';
export const EXECUTE_GLOBAL_SEARCH = '@@affectli/search/EXECUTE_GLOBAL_SEARCH';

/**
 * Execute global search query
 *
 * @param {Object} variables - GraphQL query variables
 * @param {number} variables.startIndex - Start index for pagination
 * @param {number} variables.stopIndex - Stop index for pagination
 * @param {string} variables.dataType - Data type filter
 * @param {string} variables.text - Text search query
 * @param {Array} variables.filterBy - Additional filters
 * @returns {Promise<Object>} Promise resolving to formatted search results
 */
export const executeGlobalSearch = (variables) => async (dispatch, getState) => {
    const meta = Immutable(variables);
    
    dispatch({ type: EXECUTE_GLOBAL_SEARCH_STARTED, meta });

    try {
        const response = await graphql.query({
            query: globalSearchQuery,
            variables,
            fetchPolicy: 'network-only',
        });

        if (response instanceof Error) {
            throw response;
        }

        const data = _getData(response);
        const searchData = data.globalSearch || data;
        
        if (!searchData) {
            throw new Error('Search query returned no data');
        }

        const formattedResults = formatSearchResults(searchData.results);

        const payload = Immutable({
            results: formattedResults,
            totalCount: searchData.totalCount,
            hasMore: searchData.hasMore,
        });

        dispatch({ type: EXECUTE_GLOBAL_SEARCH, payload, meta });

        return {
            results: formattedResults,
            totalCount: searchData.totalCount,
            hasMore: searchData.hasMore,
        };
    } catch (error) {
        console.error('Global search failed:', error);
        dispatch({ 
            type: EXECUTE_GLOBAL_SEARCH, 
            payload: Immutable(error), 
            error: true, 
            meta 
        });
        throw error;
    }
};
